module.exports = __webpack_public_path__ + "img/music--active.3c31bb77.svg";